import { buttonSX } from '@/components/blocks/DpLibrary/DpButtonWhatsApp/style/main';
import { Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
export const DpButtonWhatsApp = ({ label, link, ...props }: { label: string; link: string }) => (
	<Button
		component="a"
		href={link}
		target="_blank"
		type="button"
		variant="contained"
		{...props}
		sx={buttonSX}
		startIcon={<WhatsAppIcon sx={{ fontSize: 'var(--font-size-xl) !important' }} />}
	>
		{label}
	</Button>
);
